import { ConfigState } from './config.state';

export const ACTION_TYPES = {
  GET_CONFIG: 'config/GET_CONFIG',
  GET_AUTH_INFO: 'config/GET_AUTH_INFO',
  GET_INFOS: 'config/GET_INFOS',
  SET_STEPS: 'config/SET_STEPS',
  GET_PROFILE: 'config/GET_PROFILE'
};

export type GetConfigAction = {
  type: typeof ACTION_TYPES.GET_CONFIG;
  payload: ConfigState;
};

export type GetAuthInfoAction = {
  type: typeof ACTION_TYPES.GET_AUTH_INFO;
  payload: { issuer: string; clientId: string };
};

export type GetInfosAction = {
  type: typeof ACTION_TYPES.GET_INFOS;
  payload: number;
};

export type SetStepsAction = {
  type: typeof ACTION_TYPES.SET_STEPS;
  payload: {
    part: string[];
    pro: string[];
  };
};
